function initNewsletter() {

  const newsletterBlock = document.getElementById("newsletter-block");
  if(!newsletterBlock) return;

  const toggle = newsletterBlock.querySelector(".newsletter-toggle");
  const hidden = newsletterBlock.querySelector(".newsletter-hidden");
  const form = newsletterBlock.querySelector(".newsletter-form");
  const button = newsletterBlock.querySelector(".newsletter-btn");
  const modal = document.getElementById("newsletter-modal");
  const closeBtn = document.querySelector(".newsletter-close");
  const discountBtn = document.querySelector(".discount-btn");

  /* COOKIE */
  function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  }

  function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  if(getCookie("newsletter_subscribed") === "true"){
    newsletterBlock.style.display = "none";
    return;
  }

  if(toggle){
    toggle.addEventListener("click", () => {
      hidden.classList.toggle("active");
    });
  }

  if(form){
    form.addEventListener("submit", function(){

      if(button.classList.contains("loading")) return;

      button.classList.add("loading");

      setTimeout(() => {
        modal.style.display = "block";
        button.classList.remove("loading");
        setCookie("newsletter_subscribed", "true", 30);
      }, 1000);

    });
  }

  if(closeBtn){
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
    });
  }

  if(discountBtn){
    discountBtn.addEventListener("click", () => {
      setCookie("newsletter_subscribed", "true", 30);
    });
  }

}

document.addEventListener("DOMContentLoaded", initNewsletter);
document.addEventListener("shopify:section:load", initNewsletter);
